module.exports = "/fonts/iconsminds.woff?17d655d7a1a83c50d7ac2511c0377732";